import React from 'react';
import { Column } from "rbx";
import { useParams } from "react-router-dom";
import Layout from "../../layout";
import PdvNewForm from '../../../components/pdv/new';

const PdvNewScreen = () => {
  const { cpf } = useParams();

  return (
    <Layout>
      <Column.Group centered>
        <Column size={5}>
          <PdvNewForm cpf={cpf} />
        </Column>
      </Column.Group>
    </Layout>
  )

}

export default PdvNewScreen;
